import type { Session } from '@supabase/supabase-js';
import type { EstadoDoMotor } from '@sheafyield/sync';
import { useEffect, useState, useSyncExternalStore } from 'react';

import { cliente, motor } from './contexto.js';

interface MotorObservavel {
  estado(): EstadoDoMotor;
  assinar(ouvinte: (e: EstadoDoMotor) => void): () => void;
}

export function useEstadoDoMotorDe(m: MotorObservavel): EstadoDoMotor {
  return useSyncExternalStore(
    (cb) => m.assinar(cb),
    () => m.estado(),
    () => m.estado(),
  );
}
export function useEstadoDoMotor(): EstadoDoMotor {
  return useEstadoDoMotorDe(motor);
}

// undefined enquanto a sessão persistida ainda não foi lida.
export function useSessao(): Session | null | undefined {
  const [sessao, setSessao] = useState<Session | null | undefined>(undefined);
  useEffect(() => {
    let viva = true;
    void cliente.auth.getSession().then(({ data }) => {
      if (viva) setSessao(data.session);
    });
    const { data } = cliente.auth.onAuthStateChange((_e, s) => {
      if (viva) setSessao(s);
    });
    return () => {
      viva = false;
      data.subscription.unsubscribe();
    };
  }, []);
  return sessao;
}
